import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'clink-multiline-text',
    templateUrl: './multiline-text.component.html',
    styleUrls: ['./multiline-text.component.less'],
})
export class MultilineTextComponent implements AfterViewInit {
    @Input() content = ''; // 展示文案
    @Input() unfoldMsg = '查看更多'; // 展开提示
    @Input() foldMsg = '收起更多'; // 收起提示
    @Input() msgColor = '#4385ff'; // 提示颜色
    @ViewChild('contentRegion', { static: false })
    private contentRegion: ElementRef | undefined; // 文本展示元素

    seeMore = false; // 是否展开
    hasWord = false;

    constructor(private cd: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        this.watchChange();
    }

    /**
     * 判断是否展示展开提示
     */
    watchChange(): void {
        const contentRegion = this.contentRegion?.nativeElement;
        if (contentRegion.clientHeight > 66) {
            this.seeMore = true;
            contentRegion.classList.add('multiline-more');
            contentRegion.classList.remove('display-put');
        } else {
            this.seeMore = false;
            contentRegion.classList.add('display-put');
            contentRegion.classList.remove('multiline-more');
        }
        this.cd.detectChanges();
    }

    /**
     * 查看/收起 更多
     */
    readMore(event: boolean): void {
        if (event) {
            // 展开
            this.seeMore = false;
            this.hasWord = true;
            this.contentRegion?.nativeElement.classList.add('display-put');
            this.contentRegion?.nativeElement.classList.remove('multiline-more');
        } else {
            // 收起
            this.seeMore = true;
            this.hasWord = false;
            this.contentRegion?.nativeElement.classList.add('multiline-more');
            this.contentRegion?.nativeElement.classList.remove('display-put');
        }
    }
}
